import Rails from '@rails/ujs';
Rails.start();
import * as ActiveStorage from '@rails/activestorage';
ActiveStorage.start();
import 'trix';
import '@rails/actiontext';

import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-mono/400.css';

require('stylesheets/application.scss');
require('stylesheets/datatables.scss');

import $ from 'jquery';
window.$ = $;
window.jQuery = $;

require('javascripts/autocomplete.js');
require('javascripts/tooltip_standardizer.js');
require('javascripts/theme_toggle.js');
require('javascripts/site_announcement_bar.js');
require('javascripts/clickable_rows.js');

const images = require.context('../images', true);

const loadedLazyModules = new Set();

const lazyModules = [
  {
    key: 'datatables',
    selector: '#filingAggregated, #filingDetailed, #filingComparison, #managerCusipHoldings, #allCusipHoldings, #managerFilings, #trendsBuys, #trendsSells',
    load: async () => {
      await import('datatables.net-dt');
      await import('datatables.net-buttons/js/buttons.html5');
      await import('datatables.net-fixedheader-dt');
      await import('datatables.net-fixedheader-dt/css/fixedHeader.dataTables.css');
      await import('../javascripts/datatables');
    }
  },
  {
    key: 'fund-snapshot',
    selector: '#fund-snapshot-data',
    load: async () => {
      await import('../javascripts/line_chart_renderer');
      await import('../javascripts/fund_snapshot');
    }
  },
  {
    key: 'fund-sector-history',
    selector: '[data-fund-sector-history-root]',
    load: async () => {
      await import('../javascripts/fund_sector_history');
    }
  },
  {
    key: 'filing-snapshot',
    selector: '#filing-snapshot-data',
    load: async () => {
      await import('../javascripts/filing_snapshot');
    }
  },
  {
    key: 'ticker-page',
    selector: '#ticker-page-data',
    load: async () => {
      await import('../javascripts/line_chart_renderer');
      await import('../javascripts/ticker_page');
    }
  },
  {
    key: 'trends-page',
    selector: '#trends-search, [data-trends-table]',
    load: async () => {
      await import('../javascripts/trends');
    }
  },
  {
    key: 'sector-performance',
    selector: '[data-sector-performance-page]',
    load: async () => {
      await import('../javascripts/sector_performance');
    }
  },
  {
    key: 'fund-flow-heatmap',
    selector: '[data-fund-flow-heatmap-root]',
    load: async () => {
      await import('../javascripts/fund_flow_heatmap');
    }
  },
  {
    key: 'home-performance-chart',
    selector: '[data-home-performance-chart]',
    load: async () => {
      await import('../javascripts/home_performance_chart');
    }
  },
  {
    key: 'manager-aum',
    selector: '#manager-holdings-value-data',
    load: async () => {
      await import('../javascripts/line_chart_renderer');
      await import('../javascripts/manager_aum');
    }
  },
  {
    key: 'manager-cusip-history-v2',
    selector: '#manager-cusip-shares-chart-data',
    load: async () => {
      await import('../javascripts/line_chart_renderer');
      await import('../javascripts/manager_cusip_history_v2');
    }
  },
  {
    key: 'insiders-form4',
    selector: '[data-form4-insiders]',
    load: async () => {
      await import('../javascripts/insiders_form4');
    }
  },
  {
    key: 'ownership-13d13g',
    selector: '[data-ownership-13d13g]',
    load: async () => {
      await import('../javascripts/ownership_13d13g');
    }
  },
  {
    key: 'statistics-fund-counts',
    selector: '[data-fund-counts-chart]',
    load: async () => {
      await import('../javascripts/statistics_fund_counts');
    }
  }
];

function loadLazyModules() {
  lazyModules.forEach((entry) => {
    if (!document.querySelector(entry.selector)) return;
    if (loadedLazyModules.has(entry.key)) return;

    loadedLazyModules.add(entry.key);
    entry.load().catch((error) => {
      console.error(`Failed to load module ${entry.key}`, error);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadLazyModules);
} else {
  loadLazyModules();
}

document.addEventListener('turbo:load', loadLazyModules);
document.addEventListener('turbolinks:load', loadLazyModules);
window.addEventListener('pageshow', loadLazyModules);
